import cx from 'classnames'
import type React from 'react'

import { isProPlan, isTeamPlan } from '@/constants/userSubscriptionPlans'
import css from './Badge.module.scss'
import type { Classnames, Props } from './types'

const Badge: React.FC<Props> = ({
  type,
  onClick,
  isGray = false,
  cursorDefault,
  // @ts-expect-error
  children,
}) => {
  const cssType = type ? type.replace('plan_', '') : ''

  const classes: Classnames = {
    container: cx(css.container, type && css[cssType], {
      [css.gray]: isGray,
      [css.cursorDefault]: cursorDefault,
    }),
  }

  const planType =
    type && isTeamPlan(type)
      ? 'team'
      : type && isProPlan(type)
        ? 'pro'
        : cssType

  return (
    <div className={classes.container} onClick={onClick || (() => {})}>
      {children || planType}
    </div>
  )
}

export default Badge
